import * as Yup from 'yup';

export const validationSchemaForUserRole = () => {
    let validationSchema = {}
    return validationSchema = Yup.object().shape({
    rolename: Yup.string().required('Enter User’s Role Name'),
})
}